<template>
	<v-row
		dense
		no-gutters
		justify = "center"
		align   = "center"
	>
		<v-col
			xl 	 = "12"
			lg 	 = "12"
			md 	 = "12"
			sm 	 = "12"
			xs 	 = "12"
			cols = "12"
		>
			<v-card outlined>
			
				<v-card-text>
					<v-row>
						
						<v-col 
							cols 	= "5"
							v-show 	= "show.add"
						>
							<v-card 
								outlined
							>
								<v-card-title
									class = "pa-0 pl-1  primary body-2 white--text"
								>

									<v-icon
										small
										color = "white"
										class  = "mx-1"
									>
										mdi-account-multiple-plus
									</v-icon>
									<span
									>
										{{ sub_title }}										
									</span>
									
									<v-spacer></v-spacer>

								</v-card-title>	
								<v-card-text
									class = "pa-1 "
								>
								<v-row
									no-gutters
									justify = "center"
									align 	= "center"
								>	
									<template
										v-for = "(item_field, idx_field) of info_fields "
										
									>			
									<!-- v-if  = "item_field.enable"			 -->
										<v-col 
											cols = "11"
											:key = "idx_field"
										>
											<v-text-field
												dense
												outlined
												hide-details
												v-if 		 = "item_field.type == 'text' || item_field.type == 'number' || item_field.type == 'password' "
												v-model 	 = "info[item_field.key]"
												:label  	 = "$ml.get(item_field.text)"
												:type 		 = "item_field.type"
												class 		 = "mt-2"
												v-show 		 = "item_field.enable"
												:placeholder = "item_field.placeholder ? $ml.get(item_field.placeholder) : ''"
												@click 		 = "$Helper.keyboard_is_active(item_field.key, ID_notification, 'obj', 'info', info[item_field.key])"	
											></v-text-field>
												<!-- @input 	= "v => { v = input[item_field.key] }" -->
												<!-- :disabled = "item_field.enable"								 -->
												<!-- @input  = "v => { info[item_field.key] = v.toUpperCase()}"		 -->
											
											<v-select
												dense
												outlined
												hide-details
												v-if 		= "item_field.type == 'select'"
												v-show 		= "item_field.enable"												
												:label 		= "$ml.get(item_field.text)"
												v-model 	= "info[item_field.key]"
												:items 		= "render_listeds(item_field.list)"
												:item-text  = "item_field.item_text"
												:item-value = "item_field.value" 
												class 		= "my-2"
											>
												<!-- @input 		= "render_input(item_field.key)" -->
												<!-- return-object -->
												<!-- multiple -->
												<template v-slot:selection="{ item, index }">
											        <v-chip x-small 
											        	v-if = "index < 3">
											          <span>{{ item }}</span>
											        </v-chip>
											        <span
											          v-if  = "index == 4"
											          class = "grey--text caption"
											        >
											          (+{{ info[item_field.key].length - 3 }} others)
											        </span>
											      </template>
											</v-select>
										</v-col>
									</template>
								</v-row>

								</v-card-text>
								<v-divider></v-divider>
								<v-card-actions>
									<v-spacer></v-spacer>

									<v-progress-circular
								      	indeterminate
								      	color  = "primary"
								      	v-show = "show_progress"
								    	:size  = "20"
								    	:width = "4"
								    ></v-progress-circular>

									<v-btn
										x-small
										v-show 		= "!show_progress"
										color  		= "primary"										
										@click 		= "actions(btn_action)"
										:disabled 	= "!required_info"
									>
										{{ $ml.get(btn_action) }}
									</v-btn>
									<!-- <v-btn
										x-small
										color 	  =  "error"
										:disabled = "btn_action == 'update' ? false : true"
										v-text    = "$ml.get('delete')"						
										@click    = "actions('confirm_delete')"
									></v-btn> -->
								</v-card-actions>
							</v-card>
							<v-divider class = "my-1"></v-divider>
							<template
							v-show = "show.add"
						>
							<v-toolbar
					    		dense
					    		height = "25"
					    		class  = "blue-grey darken-1 white--text"
					    	>
					    		<v-icon
									small
									color = "white"
									class = "mr-1"
								>
									mdi-view-list
								</v-icon>
					    		<v-toolbar-title 
					    			class = "body-2"
					    		>
					    			{{ $ml.get(head.table_dev)}}
					    		</v-toolbar-title>
					    		<v-spacer></v-spacer>
					    		<template
						    		v-for 	= "(btn_permission, idx_permission) of btn_options_permissions"
					    		>
					    			
						    		<v-tooltip
						    			bottom
						    		>
						    			<template
						    				v-slot:activator = "{ on }"
						    			>
						    				<v-btn
						    					fab
						    					x-small
						    					:key 	= "idx_permission + 'btn_permission'"
						    					:color 	= "btn_permission.color"
						    					@click  = "actions(btn_permission.action, btn_permission)"
						    					v-on	= "on"
						    					height  = "20"
						    					width 	= "20"
						    					v-show 	= "show[btn_permission.key]"
						    					:class 	= "btn_permission.class"

						    				>
						    					<v-icon
						    						x-small
						    					>					    					
						    						{{ btn_permission.icon }}
						    					</v-icon>
						    				</v-btn>
						    			</template>
						    			<span>
						    				{{ btn_permission.text }}
						    			</span>
						    		</v-tooltip>
					    		</template>
					    			
					    	</v-toolbar>
							<v-card 
								outlined
								v-show 	= "show.show_add_permission"

							>
								<v-card-title
									class = "pa-0 primary body-2"
								>
									<v-icon
										x-small
										fab
										color = "white"
										class = "mx-1"
									>
										mdi-lock-open-plus
									</v-icon>
									<span>
										{{ $ml.get("add_permission") }}
									</span>

								</v-card-title>
								<v-card-text
								>
									<v-row
										no-gutters
										justify = "center"
										align 	= "center"
									>	
										<template
											v-for = "(item_permission_field, idx_permission_field) of info_permissions_fields "
											
										>			
										<!-- v-if  = "item_permission_field.enable"			 -->
											<v-col 
												:cols 	= "item_permission_field.cols"
												:key 	= "idx_permission_field"
											>
												<v-text-field
													dense
													outlined
													hide-details
													v-if 		 = "['text', 'number'].includes(item_permission_field.type)"
													v-model 	 = "info_permission[item_permission_field.key]"
													:label  	 = "item_permission_field.text"
													:type 		 = "item_permission_field.type"
													class 		 = "mt-2"													
													:placeholder = "item_permission_field.placeholder ? $ml.get(item_permission_field.placeholder) : ''"
													@click 		 = "$Helper.keyboard_is_active(item_permission_field.key, ID_notification, 'obj', 'info', info_permission[item_permission_field.key])"	
												></v-text-field>
												<v-card 
													outlined 
													class 		= "pa-0 caption pb-1 pl-1 mt-1" 
													height 		= "40"																			
													v-else-if 	= "item_permission_field.type == 'switch'">
													<v-switch			
														dense						
														hide-details
														class 			= "mt-1"			
														v-model 		= "info_permission[item_permission_field.key]"									
														:label 			= "item_permission_field.text"
														:prepend-icon 	= "item_permission_field.icon"
														:true-value 	= "item_permission_field.value"
													></v-switch>
														
												</v-card>
											</v-col>
										</template>
									</v-row>
								</v-card-text>
								<v-card-actions>
									<v-btn
										x-small
										color 	= "primary"
										@click 	= "actions('save_permission')" 
									>
										{{ $ml.get("save") }}
									</v-btn>
								</v-card-actions>
							</v-card>
							<v-divider></v-divider>

							    <!-- show-select -->
							<v-data-table
								dense
							    fixed-body
							    fixed-header
							    hide-default-footer
								class 				 = "elevation-1"
								:items 				 = "permissions"
								:headers 			 = "header_table_dev"
								:options.sync 		 = "options_dev"
							   	:server-items-length = "total_dev"
							   	loading-text 		 = "Loading... Please wait"
							   	:loading 			 = "loading_dev"
							    item-key 			 = "id"
							    :height  			 = "(layout_height - 200) + 'px'"
							   	:footer-props  		 = "{
							   		// showFirstLastPage 	: true,
							   		itemsPerPageOptions : [/*15, 30*/],
							   		showCurrentPage 	: false,
							   		itemsPerPageText 	: ''
							   	}"
							   	
							>
								 <template v-slot:top >
								 	<v-text-field
								 		dense
								 		outlined
								 		hide-details
								 		v-model 			= "search_permission"
								 		:label 				= "$ml.get('search')"
								 		prepend-inner-icon 	= "mdi-magnify"
								 		class 				= "my-1"
								 	></v-text-field>
								 </template>     
								<template 
									v-for = "item_permission of permission_options"
									v-slot:[`item.${item_permission}`]="{ item, index }" 
								>

									<v-btn
										x-small
										:color  = "item[item_permission] ? 'primary' : 'secondary'"
										@click  = "actions(head.action_table_permission, item, item_permission)"
									>
										<span>
											{{ item[item_permission] ? $ml.get('on') :$ml.get('off') }}
										</span>
									</v-btn>	
								</template>
								<template v-slot:item.actions = "{ item }"  >
									<!-- <v-btn
										x-small
										color  = "primary"
										@click = "actions('edit', item)"
										
									>
										<v-icon
											x-small
											
										>
											mdi-pencil
										</v-icon>
									</v-btn>	 -->
									<v-btn
										x-small
										color  = "error"
										@click = "actions('confirm_delete_dev', item)"										
									>
										<v-icon
											x-small
											
										>
											mdi-delete
										</v-icon>
									</v-btn>							
								</template>
							</v-data-table>
							    <!-- v-model 			 = "selection_devices" -->
						</template>
						</v-col>
						
						<v-col

						>

							<v-toolbar
					    		dense
					    		height = "25"
					    		class  = "secondary white--text"
					    	>
					    		<v-icon
									small
									color = "white"
									class = "mr-1"
								>
									mdi-view-list
								</v-icon>
					    		<v-toolbar-title 
					    			class = "body-2"
					    		>
					    			{{ $ml.get(head.table)}}
					    		</v-toolbar-title>
					    			<v-spacer></v-spacer>
					    			<v-btn
					    				x-small
					    				fab
					    				height = "25"
					    				:color  = "!show.add ? 'primary' : 'error'"
					    				@click = "actions('show')"

					    			>
					    				<v-icon>

					    					{{ !show.add ? 'mdi-plus' : 'mdi-close' }} 
					    				</v-icon>
					    			</v-btn>
					    	</v-toolbar>
							
							<v-divider></v-divider>

							<v-data-table
								dense
							    fixed-body
							    fixed-header
								class 				 = "elevation-5"
								:items 				 = "render_list"
								:headers 			 = "header_table"
								:options.sync 		 = "options"
							   	:server-items-length = "total"
							   	loading-text 		 = "Loading... Please wait"
							   	:loading 			 = "loading"
							    item-key 			 = "id"
							    :height  			 = "layout_height + 'px'"
							   	:footer-props  		 = "{
							   		showFirstLastPage 	: true,
							   		itemsPerPageOptions : [15, 30],
							   		showCurrentPage 	: true,
							   		itemsPerPageText 	: ''
							   	}"
							   	
							>
							    <!-- rowsPerPageText: [30] -->
								<template v-slot:item.actions = "{ item }"  >
									<v-btn
										x-small
										color  = "primary"
										@click = "actions('edit', item)"
										v-show = "item.name != 'SuperAdmin'"
										
									>
										<v-icon
											x-small
											
										>
											mdi-pencil
										</v-icon>
									</v-btn>	
									<v-btn
										x-small
										color  = "error"
										@click = "actions('confirm_delete', item)"
										v-show = "item.name != 'SuperAdmin'"
									>
										<v-icon
											x-small
											
										>
											mdi-delete
										</v-icon>
									</v-btn>							
								</template>
								<template v-slot:item.createdAt = "{ item }" >								
									{{ item.date }} 
								</template>
								<template v-slot:item.manager_id = "{ item }" >
									<v-chip 
										x-small
										:color = "!item.manager_id ? 'secondary' : 'success'"
									>
										<span>											
											{{ item.manager_id ? item.manager_id : $ml.get('data_no_found') }} 
										</span>
									</v-chip>
								</template>
								
							</v-data-table>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</v-col>
	</v-row>
</template>
<script>
	import EventBus from '@/event-bus'
	export default{
		name : 'roles',
		data : (vm) => ({
			info 			: {},
			info_permission : {},
			input 			: {},
			head 			: {
				title  					: 'roles',
				// title1 				: 'lpr',
				table  					: 'registered_roles',
				table_dev 				: 'registered_permissions',
				action_table_permission : 'change_value_permission',
			}, 
			info_fields : [
 				{
					key  : 'name',
					text : 'role',
					type : 'text',
					// list : ['cloud','module', 'streaming', 'guardian_cloud', 'external_client'],
					enable : true,
					/*value  : '',
					item_text   : ''*/
 				},
				
				

				

			],
			show 			: {
				add 					: false,
				add_permission  		: true,
				show_add_permission  	: false,
				unlisted_permissions 	: true,
			},
			sub_title 		: vm.$ml.get('register'),			
			show_progress 	: false,
			btn_action 	  	: 'save',
			header_table  	: [
				{ text: vm.$ml.get('name'), value: 'name', align: 'center' },
				// { text: vm.$ml.get('ip_address'), value: 'ip_address', align: 'center' },
				// { text: vm.$ml.get('type_integrate'), value: 'type_integrate', align: 'center' },
				// { text: vm.$ml.get('type_encode_media'), value: 'type_encode_media', align: 'center' },
				{ text: vm.$ml.get('date'), 'value': 'createdAt', align: 'center'},
				{ text: vm.$ml.get('actions'), value: 'actions', align: 'center'}
			],
			header_table_dev  : [
				{ text: vm.$ml.get('name'), value: 'name' },
				{ text: vm.$ml.get('add'), value: 'can_add' },
				{ text: vm.$ml.get('view'), value: 'can_view' },
				{ text: vm.$ml.get('edit'), value: 'can_edit' },
				{ text: vm.$ml.get('delete'), value: 'can_delete' },
				{ text: vm.$ml.get('actions'), value: 'actions', align: 'center'}
			],
			options 	  			: { },
			total 		  			: 0,
			layout_height 			: 400,
			ID_notification 		: 'listing_details',
			loading 	  			: false,
			list_lists 	  			: [],
			list 		  			: [], 
			required_info 			: true,
			list_profiles 			: [],
			bus 		  			: {},
			selection_devices 		: [],
			options_dev  			: {},
			total_dev   			: 0,
			loading_dev 			: false, 
			info_permission 		: {},
			list_permissions 		: [], 	
			permission_options 		: ['can_edit', 'can_view',  'can_add', 'can_delete'],
			search_permission  		: "",
			btn_options_permissions : [
				{
					key 		: "unlisted_permissions",
					color 		: "primary",
					action 		: 'add_unlisted_permissions',			
					text 		: vm.$ml.get("add_unlisted_permissions"),		
					icon 		: "mdi-notebook-plus",
					class 		: "mx-2",
				},
				{
					key 		: "add_permission",
					color 		: "primary",
					action 		: 'add_permission',					
					text 		: vm.$ml.get("add_permission"),		
					icon 		: "mdi-plus",

				},
			],
			info_permissions_fields : [
				{
					key 	: "name",
					type 	: "text",
					text 	: vm.$ml.get("name"),
					class 	: "",
					icon 	: "mdi-rename-box",
					cols 	: "12",
				},
				{ //  can_add, can_view, can_edit , can_delete			
					key 	: "can_add",
					type 	: "switch",
					text 	: vm.$ml.get("can_add"),
					class 	: "",
					cols 	: "6",
				},
				{ 
					key 	: "can_view",
					type 	: "switch",
					text 	: vm.$ml.get("can_view"),
					class 	: "",
					cols 	: "6",
				},
				{ 
					key 	: "can_edit",
					type 	: "switch",
					text 	: vm.$ml.get("can_edit"),
					class 	: "",
					cols 	: "6",
				},
				{ 
					key 	: "can_delete",
					type 	: "switch",
					text 	: vm.$ml.get("can_delete"),
					class 	: "",
					cols 	: "6",
				}

			]

		}), // data

		created(){
			if (this.$route.name == 'list_face') {
				this.head.title1 = 'face';
				this.header_table.splice(0, 1, { text : this.$ml.get('entity'), value : 'entity' })
			}
			let obj_new =  this.$Helper.set_property_obj(this.info_fields);
			if (obj_new) {
				this.info = obj_new;
			}
			this.get_permisions();

			// this.get_listing()
			// this.get_profiles();
				
		}, // created

		watch : {
			options : { 
				handler(){
					this.get_list();
				}, deep : true
			}, // options			
		
		}, // watch

		computed : {
			
			render_list : function(){
				return this.list;
			}, // render_list

			/*devices : function(){
				let devs 		= this.$store.getters["Devices/list"];

				if (devs && devs.length) {
					this.total_dev 	= devs.length;
				}else {
					this.total_dev 	= 0;

				}
				return devs;
			},*/

			permissions : function(){
				if (this.list_permissions && this.list_permissions.length) {
					this.total_dev = this.list_permissions.length; 
				}
				let list = this.list_permissions;
				if (this.search_permission) {
					list = this.list_permissions.filter(x => (x && x.name && x.name.toLowerCase().includes(this.search_permission.toLowerCase())))
				}
				return list;
			}

		}, // computed

		methods : {
			actions(act, item, opt) {
				if (act == 'show') {
					this.show.add = !this.show.add;
					if (this.btn_action == 'update' || this.btn_action == 'save') {
						this.actions('clear_info');
					}
					if (this.show.add) {
						if (this.btn_action == 'save') {
							this.show.unlisted_permissions = false;
						}else{
							this.show.unlisted_permissions = true;

						}
						this.list_permissions = this.$store.getters["auth/list_default_permissions"];
					}
				}
				if ( act == 'clear_info') {
					this.btn_action = 'save';
					this.info 		= {};
					this.info_item  = {};
					this.sub_title 	= this.$ml.get('register');
					this.show.unlisted_permissions = true;

					// this.render_input('type_integrate');

				}
				if (act == 'save') {
					this.save();
				}
				if (act == 'update') {
					this.save(true);
				}
				if (act == 'edit') {
					this.info 		= { ...item };
					// this.info_item 	= this.list.indexOf(item);
					// this.render_input('type_integrate');

					this.show.add 					= true;
					this.sub_title 					= this.$ml.get('update');
					this.btn_action 				= 'update';
					this.info_item  				= { ...item };
					this.show.unlisted_permissions 	= true;


					/*if (item && item.devices && item.devices.length > 0) {
						this.selection_devices = item.devices;
					}*/
					this.find_permissions(item);

				}
				if ( act == 'confirm_delete') {
					this.info_item = { ...item };
					EventBus.$emit('notifications_modal',{
						type  : 'confirm_delete',
						ID 	  : this.ID_notification,
					});

				}else 
				if (act == "confirm_delete_dev"){
					this.info_item = { item : {...item}, action : "delete_permission" };
					EventBus.$emit('notifications_modal',{
						type  : 'confirm_delete',
						ID 	  : this.ID_notification,
					});
				}
				if ( act == 'change_value_permission') {
					let idx = this.list_permissions.findIndex(x => (x &&  x.name == item.name)); 
					if (idx >= 0) {
						this.list_permissions[idx][opt] = !this.list_permissions[idx][opt]; 
						if (this.btn_action == "update") {
							this.update_permission(this.list_permissions[idx]);
						}
					}
					console.log(" actions ", act, item, opt, this.list_permissions[item]);

				}else 
				if (act  == "add_unlisted_permissions"){
					this.save_unlited_permissions();
				}else
				if (act == "add_permission") {
					this.show.show_add_permission = !this.show.show_add_permission;
				}else
				if (act == "save_permission") {					
					this.save_permission();
				}
			}, // actions

			render_listeds(list){
				if (this[list]) {
					return this[list];
				}else{
					return list;
				}

			}, // render_list

			get_list(){
				const { itemsPerPage, page } = this.options;
				const api 	 = this.$URL + '/api/v1/role/?page=' + page;
				this.loading = true;
				
				this.$axios.get(api).then( res => {
					console.log(res, 'res get_list');
					let items = res.data.rows;
					if (items && items.length > 0) {
						items.forEach((list_item) =>{
							if (list_item) {
								let temp = this.format_info(list_item);
								if (temp){
									list_item = temp; 
								}
							}
						})
					}
					this.total 	 = res.data.count;
					this.list  	 = [ ...items];
					this.loading = false;

				}).catch( er => {
					this.loading = false;					
					console.log(er, 'Error get_list');
					let  err = er && er.message ? er.message : er;
						

					this.$EventBus.$emit('notifications_modal',{
						type  	: 'error',
						message :  err
					});
				})

			}, // get list


			
			get_permisions(){
				
				// const { itemsPerPage, page } = this.options;
				// let pg 		= 1;
				// let vm 		= this;
				// const api 	= this.$URL + '/api/v1/permission/?page=' + pg;
				// this.loading = true;
				// let info_up = this.$store.getters(["auth/list_permissions"])
				this.list_permissions 	= this.$store.getters["auth/list_default_permissions"];
				this.total_dev 			= this.list_permissions && this.list_permissions.length > 0 ? this.list_permissions.length : 0;
				/*this.loading_dev = true;
				this.$axios.get(api).then( res => {
					console.log(res, 'res get_list');
					let items 	  		= res.data.rows;
					// this.total = res.data.count;
					this.loading_dev 	= false;

					this.total_dev = res.data.count;
					let temp_list = [];

					if (items && items.length > 0) {
						items.forEach((item_list) => {
							if (item_list) {
								temp_list.push(item_list);
							}
						})
					}
					console.log(" LISTS : ", temp_list, items)
					if (temp_list && temp_list.length > 0) {

						// this.list_permissions  	= [ ...temp_list ];
						// this.required_info 		= true;
					}else{

						this.$EventBus.$emit('notifications_modal', {
							type 	: 'warning',
							message : ' Required have list permissions'
						})
					}
					// this.loading = false;

				}).catch( er => {
					// this.loading = false;					
					this.loading_dev 	= false;
					console.log(er, 'Error get_list');
					let err = er && er.message ? er.message : er;
					this.$EventBus.$emit('notifications_modal',{
						type 	: 'warning',
						message : 'Failed Get de permissions : ' + err
					})
					this.list_permissions = this.$store.getters["auth/list_permissions"];
					console.log("permissions  --------------------------...", this.list_permissions)
				})*/
			}, // get permissions

			find_permissions(item){
				const api 	= this.$URL + '/api/v1/permissions/find'; // ?page=' + pg
				// this.loading = true;
				// let info_up = this.$store.getters(["auth/list_permissions"])
				this.loading_dev 	= true;
				this.$axios.post(api, item).then( res => {
					console.log(res, 'res get_list');
					if (res && res.data && res.data.rows && res.data.rows.length > 0) {					
						this.list_permissions = [ ...res.data.rows ];
					}
					this.loading_dev 	= false;
				}).catch(er => {
					console.log("Error find permission role ", er)
					this.loading_dev 	= false;

				})
			}, // find permissions

			save(up){
				let opt 	= 'post';
				let info_up = { ...this.info };
				let api 	= this.$URL + '/api/v1/role';
				let check  	= false;
				let msg 	= ''; 
				// info_up["devices"] = this.selection_devices;
				info_up["permissions"] = this.list_permissions;
				this.loading = true;

				if (up) {
					opt = 'put';					
					msg = 'Not found id'
					if (info_up && info_up.id ) {
						api   += '/' + info_up.id;
						check  = true;
						msg    = '';
					}
				}else{
					check = true;
				}

				/*if (!info_up.listId) {
					check = false;
					msg   = this.$ml.get('require_sel_list')
				}*/
				if (check) {
					this.$axios[opt](api, info_up).then( res => {
						console.log('res ', opt, 'roles', res );
						this.$EventBus.$emit('notifications_modal',{
							type : up ? 'updated' : 'saved', 
						});
						this.loading = false;
						// this.$router.back();
						if (!up) { // save
							this.total ++;
							let info_res = this.format_info(res.data);
							this.list.push(info_res);
						}else{
							let idx = this.list.indexOf(this.info_item);
							// console.log("update list : ", idx)
							// this.info_item = info_up;
							if (idx >= 0) {
								this.list.splice(idx, 1, info_up);
							}
						}
			    		// this.info_fields[2].enable 	= false;
			    		this.selection_devices 		= [];

						if (this.show.add) {
							this.actions('show');
						}
					}).catch(er => {
						this.loading = false;						
						console.log("Error list setting ", opt, er);
						let  err 	 = up ? 'update ' : 'save ';
						err 	 	+= er && er.message ? er.message : er;

						this.$EventBus.$emit('notifications_modal',{
							type  	: 'error',
							message :  err
						});

					})

				}else{
					this.$EventBus.$emit('notifications_modal',{
						type  	: 'error',
						message :  msg
					});
					this.loading = false;

				}
			}, // save

			/*save_pemissions(){
				const api 	= this.$URL + '/api/v1/permission';
				let info_up = this.info_permission;
				this.loading_permission = true;
				this.$axios.post(api, info_up).then(res => {
					console.log("permissions res : ", res)
					this.$EventBus.$emit("notifications_modal",{
						type 	: "saved",
						message : this.$ml.get("permissions")
					})
					this.loading_permission = false;

				}).catch(err => {
					console.log("err permission save ", err)
					this.$EventBus.$emit("notifications_modal",{
						type 	: "error",
						message : err
					});
					this.loading_permission = false;


				})
			}, // save permissions

			update_pemissions(item){
				const api 	= this.$URL + '/api/v1/permission';
				let info_up = item;//this.info_permission;
				this.loading_permission = true;
				this.$axios.put(api, info_up).then(res => {
					console.log("permissions res update : ", res)
					this.$EventBus.$emit("notifications_modal",{
						type 	: "updated",
						message : this.$ml.get("permissions")
					})
					this.loading_permission = false;

				}).catch(err => {
					console.log("err permission update ", err)
					this.$EventBus.$emit("notifications_modal",{
						type 	: "error",
						message : err
					});
					this.loading_permission = false;
					

				})
			}, // update permissions*/

			del(item){
				if (item) {
					let idx = this.list.indexOf(item);
					if (item.id) {
						this.loading = true;
						const api 	 = this.$URL + '/api/v1/cloud/' + item.id;
						this.$axios.delete(api).then(res =>{
							this.$EventBus.$emit('notifications_modal',{
								type : 'deleted', 							
							});
							this.list.splice(idx, 1);
							if (this.list && this.list.length === 0) {
								this.total = 0;
							}else{
								this.total = this.list && this.list.length == 1 ? 1 : this.list.length - 1;
							}
							this.loading   = false;							
							if (this.show.add) {
								this.actions('show');
							}
						}).catch( er => {
							console.log( "Error deleting ", er);
							this.loading = false;
							let  err 	 = up ? 'update ' : 'save ';
							err 		+= er && er.message ? er.message : er;
							this.$EventBus.$emit('notifications_modal',{
								type  	: 'error',
								message :  'Deleting item ' + err
							});
						})
					}else{
						this.$EventBus.$emit('notifications_modal',{
							type  	: 'warning',
							message :  'Item to delete have id'
						});	
					}
				}else{
					this.$EventBus.$emit('notifications_modal',{
						type  	: 'warning',
						message :  'Item to delete null'
					});
				}
			}, // del item

			format_info(item){
				if (item){
					if (item.listId) {
						let temp_lists = this.list_lists[this.list_lists.findIndex( x => x.id == item.listId)] ;						
						item.list = temp_lists ? temp_lists.name : false;
						
					}		
					if (item.createdAt) {
						item.date  = this.$momentz(item.createdAt).format('ll, LTS');
					}
					return item;			
				}
				return null
			}, // format info

			render_input(key){
				if (key == 'type_integrate' && this.info[key]){
					console.log("key : ", key,this.info[key])
					if(this.info[key] == 'cloud'){
			    		this.info_fields[1].enable 	= true;
		    			this.info_fields[2].enable  = true;
		    			this.info_fields[4].enable 	= false;
			    		this.info_fields[5].enable 	= false;
			    		this.info_fields[6].enable 	= false;

			    		delete this.info.name;
						delete this.info.port_socket;
			    	}
			    	else{
			    		this.info_fields[2].enable 	= false;
		    			delete this.info.name;
						delete this.info.port_socket;

			    		if (this.info.manager_id) {
			    			delete this.info.manager_id;
			    		}
			    		if (["module"].includes(this.info[key])) {
			    			this.info_fields[1].enable 	= true;
			    		}else{
			    			this.info_fields[1].enable 	= false;

			    		}
			    		if (this.info[key] == "guardian_cloud") {
			    			this.info_fields[4].enable 	= true;
			    			this.info_fields[5].enable 	= true;
			    			this.info_fields[6].enable 	= false;

			    		}else 
			    		if (this.info[key] == "external_client"){
			    			this.info_fields[4].enable 	= false;			    			
			    			this.info_fields[5].enable 	= true;
			    			this.info_fields[6].enable 	= true;

			    		}else{
			    			this.info_fields[4].enable 	= false;
			    			this.info_fields[5].enable 	= false;
			    			this.info_fields[6].enable 	= false;
			    			
			    		}
			    		
			    	}
				}else{
					// this.info_fields[2].enable = false;
				}
			}, // render input

			save_permission(){
				let info_up = { ...this.info_permission };
				if (this.info && this.info.id) { // bd
					const api 	= this.$URL + "/api/v1/permission"
					this.loading_dev 	= true;
					info_up.roleId 		= this.info.id;
					this.$axios.post(api, info_up).then(res => {
						this.loading_dev = false;
						if (res && res.data) {
							this.list_permissions.push({ ...res.data });
							this.info_permission = {};
							this.$store.commit("auth/create_permission", res.data);
							this.$EventBus.$emit("notifications_modal",{
								type 	: "saved",
								message : this.$ml.get("permissions"),
							});			
							this.actions("add_permission");				
						}
					}).catch(er => {
						this.loading_dev = false;
						console.warn("Error create permission  ", er);
						this.$EventBus.$emit("notifications_modal",{
							type 	: "error",
							message : err,
						});
					})
				}else{ // list permissions
					this.list_permissions.push({...info_up});
				}
			}, // save permission

			update_permission(item){
				if (item && item.id) {
					const api = this.$URL + "/api/v1/permission/" + item.id;
					this.loading_dev = true;
					this.$axios.put(api, item).then(res => {
						this.$EventBus.$emit("notifications_modal",{
							type 	: "updated",
							message : this.$ml.get("permissions"),
						});
						this.loading_dev = false;
						this.$store.commit("auth/update_permission", item);

					}).catch(err => {
						console.warn("Error update permisions ", err);
						this.$EventBus.$emit("notifications_modal",{
							type 	: "error",
							message : err,
						});
						this.loading_dev = false;

					})

				}else{
					console.warn("required id to update ", item);
					this.$EventBus.$emit("notifications_modal",{
						type 	: "warning",
						message : this.$ml.get("req_id_to_update"),
					})
				}
			}, // update permission
			delete_permission(item){
				if (item && item.id) {
					const api = this.$URL + "/api/v1/permission/" + item.id;
					this.loading_dev = true;
					this.$axios.delete(api).then(res => {
						this.$EventBus.$emit("notifications_modal",{
							type 	: "deleted",
							message : this.$ml.get("permissions"),
						});
						this.loading_dev = false;
						this.$store.commit("auth/delete_permission", item);
						let idx = this.list_permissions.findIndex(x => (x && x.id == item.id));
						if (idx >= 0) {
							this.list_permissions.splice(idx, 1);
						}
						

					}).catch(err => {
						console.warn("Error delete permisions ", err);
						this.$EventBus.$emit("notifications_modal",{
							type 	: "error",
							message : err,
						});
						this.loading_dev = false;

					})

				}else{
					console.warn("required id to delete ", item);
					this.$EventBus.$emit("notifications_modal",{
						type 	: "warning",
						message : this.$ml.get("req_id_del"),
					})
				}
			}, // update permission

			save_unlited_permissions(){
				if (this.info && this.info.id) {
					this.$store.dispatch("auth/diff_permissions", {
						permissions : [ ...this.list_permissions ],
					}).then(resp => {
						
						console.log("res add_unlisted_permissions ", resp )
						if (resp && resp.length > 0) {
							this.loading_dev 				= true;
							this.show.unlisted_permissions 	= false;

							const api = this.$URL + "/api/v1/permission";
							resp.forEach(async (per, idx, len) => {

								let info_up = {
				                  name        : per.name,
				                  roleId 	  : this.info.id,
				                  resourceId  : per.id,
				                  can_add     : false,
				                  can_view    : true, 
				                  can_edit    : true,
				                  can_delete  : false,
				                }

				                await this.$axios.post(api, info_up).then(res =>{
				                	if (res && res.data) {
				                		this.list_permissions.push({ ...res.data });
				                	}
				                	if (idx == len.length - 1 ) {
										this.loading_dev 				= false;
										this.show.unlisted_permissions 	= true;

										this.$EventBus.$emit("notifications_modal",{
											type  	: "saved",									
										});
									}
				                }).catch(err => {
				                	console.warn("Error create permission ", err);
				                	if (idx == len.length - 1 ) {
										this.loading_dev 				= false;
										this.show.unlisted_permissions 	= true;
									}
				                })
							})
						}else{
							// this.show.unlisted_permissions = false;
							this.$EventBus.$emit("notifications_modal",{
								type  	: "success",
								message : this.$ml.get("not_found_items_add")									
							})
						}
					});
					
					

				}else{
					console.warn("Required id to update ", this.info);
					this.$EventBus.$emit("notifications_modal",{
						type  	: "warning",
						message : this.$ml.get("req_id_to_update_list"),									
					})
				}
			}, // 

		}, // methods

		mounted(){
			let temp_bus = 'notifications_modal' + this.ID_notification; 
			EventBus.$on(temp_bus, this.bus[temp_bus] = (action) => {
				if (action) {
					if (this.info_item && this.info_item.item && this.info_item.action == "delete_permission"){
						this.delete_permission(this.info_item.item);
					}else{
						this.del(this.info_item);
					}
				}
			}); 
			temp_bus = 'keyboard_type' + this.ID_notification;
			EventBus.$on(temp_bus, this.bus[temp_bus] = (action) =>{
				if (action) {
					console.log("INPUT TYPE : ",action)
					if (action.setting ) {
						let { obj, key, type, func } =  action.setting;
						if ( action.input || action.input == "") {

							if (type == 'text') {
								if (func == 'toUpperCase') {
									this[key] = action.input[func]();

								}else{
									this[key] = action.input;
								}
							}else{
								// console.log("obj key ", this[obj][key], action.input)
								this[obj][key] = action.input;
								
							}
						}
						 
					}
				}
			});
			temp_bus = 'keyboard_type_button' + this.ID_notification;
			EventBus.$on( temp_bus, this.bus[temp_bus] = (action) =>{
				if (action) {
					if (action.setting ) {
						let { obj, key, type, func } =  action.setting;
						console.log("SEARCH EVENT 1", action.button == "{enter}", type, key)

						if (action.button == '{enter}') {
							if (type == 'text' && key == 'search') {
								console.log("SEARCH EVENT")
								// this.get_search(this.search);
							}

						}
					}
				}
			})
		}, // mounted

		beforeDestroy(){
			this.$Helper.clear_bus(EventBus, this.bus, 'integration_cloud');

		}, // beforeDestroy

	}; // export default
</script>